<template>
  <div id="trackinfo">
    <div class="input-group-add">
      <slot name="title">
        <h1 v-if="type === 2">{{ $t('userInfo') }}</h1>
        <h1 v-else-if="type === 1">{{ $t('editUser') }}</h1>
        <h1 v-else>{{ $t('addUser') }}</h1>
      </slot>
      <div style="display: flex">
        <div style="display: none">
          <label for="file" class="label-add">{{ $t('file') }}:</label>
          <input
            ref="fileInput"
            id="file"
            type="file"
            class="input-add"
            @change="handleFileUpload"
            accept=".zip"
          />
        </div>
        <button
          type="button"
          @click="update"
          class="button-update"
          v-if="updateEnable && type === 2"
        >
          {{ $t('update') }}
        </button>
        <button type="button" @click="back" class="button-back">{{ $t('back') }}</button>
      </div>
    </div>
    <slot name="info" />
    <button v-if="type !== 2" type="button" @click="submit" class="button-submit">
      {{ btnLabel }}
    </button>
  </div>
</template>
<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Swal from 'sweetalert2';
import { ref, inject } from 'vue';

export default {
  name: 'GenericInfo',
  props: {
    apiEndpoint: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      default: 0,
    },
    updateEnable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorFileMessage: '',
    };
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const btnLabel = ref(t('add'));
    const route = useRoute();
    const page = ref(route.meta.back);
    let event = 'add';
    if (props.type !== 0) {
      btnLabel.value = t('save');
      event = 'save';
    }
    function submit() {
      emit(event);
    }
    return {
      t,
      page,
      apiBaseUrl,
      btnLabel,
      submit,
    };
  },
  methods: {
    back() {
      if (this.type === 2) {
        this.$router.push(this.page);
        return;
      }
      Swal.fire({
        icon: 'warning',
        title: this.$t('exitWithoutSaving'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push(this.page);
        }
      });
    },
    update() {
      this.$refs.fileInput.click();
    },
    validateFile(file, version) {
      if (file) {
        if (file.size > 10 * 1024 * 1024) {
          this.errorFileMessage = this.t('fileSizeLimit');
          return false;
        }
        if (!file.type === 'application/zip') {
          this.errorFileMessage = this.t('zipFileOnly');
          return false;
        }
        if (version <= 0) {
          this.errorFileMessage = this.$t('updateFilenameError');
          return false;
        }
        return true;
      }
      if (!file && this.type === 1) {
        return true;
      }
      return false;
    },
    handleFileUpload(event) {
      [this.selectedFile] = event.target.files;
      const version = this.extractVersionNumber();
      if (this.validateFile(this.selectedFile, version)) {
        this.$emit('uploadFile', { file: this.selectedFile, version });
      } else {
        Swal.fire({
          title: this.errorFileMessage,
          icon: 'error',
        });
      }
    },
    extractVersionNumber() {
      const fileName = this.selectedFile.name;
      const versionRegex = /-(\d+)\.(\d+)\.(\d+)/;
      const match = fileName.match(versionRegex);
      if (match) {
        const majorVersion = parseInt(match[1], 10);
        const minorVersion = parseInt(match[2], 10);
        const hotfixVersion = parseInt(match[3], 10);
        if (majorVersion > 255 || minorVersion > 255 || hotfixVersion > 255) return -1;
        // eslint-disable-next-line no-bitwise
        const version = (majorVersion << 16) | (minorVersion << 8) | hotfixVersion;
        return version;
      }
      return -1;
    },
  },
};
</script>
<style>
.button-back {
  border: 1px solid #4285f4;
  color: #4285f4;
  width: 110px;
  height: 45px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
}

.button-update {
  border: 0px;
  background: #4285f4;
  color: white;
  width: 110px;
  height: 45px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
}

.label-add {
  flex: 0.2;
  text-align: left;
  margin-right: 10px;
  font-size: 20px;
}
</style>
